const DatePickerStates = {
    START: 'START',
    SOFT_START: 'SOFT_START',
    END: 'END',
    DONE: 'DONE',
    CLOSED: 'CLOSED'
};

const DatePickerAlertLevels = {
    ERROR: 'red',
    WARNING: 'yellow',
    INFO: 'blue',
    SUCCESS: 'green'
};

const DatePickerAlertIcons = {
    ALERT: 'ALERT_ALERT__32',
    CHECK: 'ALERT_CHECK__32',
    DANGER: 'ALERT_DANGER__32',
    INFO: 'ALERT_INFO__32',
    TAP: 'ALERT_TAP_TARGET__32'
};

const DatePickerAlertAnimations = {
    SLIDE_IN: 'slide-in-down',
    SLIDE_OUT: 'slide-out-up',
    BOUNCE: 'bounce'
};

const DatePickerAlertSpeeds = {
    SLOW: 1000,
    MEDIUM: 500,
    INSTANT: 0
};

const DatePickerAlertVisibility = {
    HIDE: 'hide',
    SHOW: 'show'
};

const DatePickerAlertTranslationData = {
    MAIN_PAGE_DATE_ERROR: 'MAIN_PAGE_DATE_ERROR',
    MIN_STAY_OF_LISTING: 'MIN_STAY_OF_LISTING',
    MIN_STAY_OF_START_DATE: 'MIN_STAY_OF_START_DATE',
    MIN_STAY_OF_CLOSEST_START_DATE: 'MIN_STAY_OF_CLOSEST_START_DATE',
    CLOSEST_DATE: 'CLOSEST_DATE'
};

export {
    DatePickerStates,
    DatePickerAlertLevels,
    DatePickerAlertIcons,
    DatePickerAlertAnimations,
    DatePickerAlertSpeeds,
    DatePickerAlertTranslationData,
    DatePickerAlertVisibility
};
